export class ProvinceCountDTO {
    province: string;
    count: number;
}

export class TripKpiDTO {
    monthlyTripCount: number = 0;
    completedTripCount: number = 0;
    scheduledTripCount: number = 0;
    scheduledTripsByProvince: ProvinceCountDTO[] = [];
    ym: string = '';
}

export class ReceptionKpiDTO {
    dailyReceptionCount: number = 0;
    heavyBoilerCount: number = 0;
    compSaleCount: number = 0;
    recentBoilerCount: number = 0;
}

export class InboundKpiDTO {
    pendingExchangeCount: number = 0;
    pendingNewExchangeCount: number = 0;
    pendingTripCount: number = 0;
}

export class RepairKpiDTO {
    totalRepairCount: number = 0;
    recentRepairCount: number = 0;
    laborChargeCount: number = 0;
    boardWaterTankCount: number = 0;
    otherRepairCount: number = 0;
    laborChargeCost: number = 0;
    ym?: string = '';
}

export class RepairStatisticsKpiDTO {
    boilerCount: number = 0;
    tripCount: number = 0;
    inspectionAmount: number = 0;      // 견적금액 (수리비 + 고객 청구 출장비)
    repairCost: number = 0;            // 수리원가
    tripFeeRevenue?: number = 0;       // ✅ 고객 청구 출장비 (수익) - 새로 추가
    tripCost: number = 0;              // 출장 비용 (출장자 지불, 비용)
    profit: number = 0;                // 이익
    startDate?: string;
    endDate?: string;
}